var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.17024 11.5087C8.19151 11.5276 8.2116 11.5453 8.23169 11.5666C9.50668 12.8735 10.2098 14.6046 10.2098 16.4421V21.1497L12.8519 19.7105C13.0599 19.597 13.1887 19.3749 13.1887 19.1303V16.4279C13.1887 14.5975 13.8847 12.8723 15.1478 11.5725L20.8634 5.49297C21.2333 5.09949 21.4365 4.58311 21.4365 4.03837V2.93236C21.4365 2.38408 21.004 1.9386 20.4747 1.9386H2.90249C2.37193 1.9386 1.93945 2.38408 1.93945 2.93236V4.03837C1.93945 4.58311 2.1427 5.09949 2.51255 5.49179L8.17024 11.5087ZM9.79264 23.2093C9.55395 23.2093 9.31762 23.1455 9.10256 23.0179C8.68662 22.7697 8.43729 22.3314 8.43729 21.8445V16.4421C8.43729 15.1009 7.93746 13.8377 7.02642 12.87C6.99924 12.8475 6.97206 12.8227 6.94843 12.7967L1.2222 6.7077C0.541572 5.98454 0.166992 5.03568 0.166992 4.03837V2.93236C0.166992 1.40686 1.39472 0.166138 2.90249 0.166138H20.4747C21.9813 0.166138 23.209 1.40686 23.209 2.93236V4.03837C23.209 5.0345 22.8344 5.98217 22.1561 6.70652L16.4287 12.7967C15.4799 13.7751 14.9611 15.0619 14.9611 16.4279V19.1303C14.9611 20.0236 14.4778 20.8413 13.7003 21.2667L10.4378 23.0439C10.2346 23.1538 10.0136 23.2093 9.79264 23.2093Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.f1473f2d86be8dfb0df3354810666f85.svg";
export { ForwardRef as ReactComponent };